import React from "react";
import { useIntl } from "react-intl";
import { Sparkle } from "@piiqtechnologies/svg-icons";
import { PeekBox, PeekTypography } from "@piiqtechnologies/ui-components";
import { useOptionalWhatsNew } from "@piiqtechnologies/ui-lib";
import { SIDEBAR_ICON_SIZE, SidebarPageItem } from "@components/common/app-sidebar/components/SidebarPageItem";
import messages from "./messages.i18n";
const MAX_SHOWN_COUNT = 99;
/**
 * The "What's New" row (FR-1): opens the list right beside itself and carries the unread count,
 * with no number at zero. Renders nothing outside a WhatsNewProvider (the feature flag is off), and
 * nothing before the very first announcement; from then on it stays, even when everything is
 * switched off and the list has nothing to show (see `hasAnnouncements`).
 */
export const WhatsNewSidebarItem = () => {
    const intl = useIntl();
    const whatsNew = useOptionalWhatsNew();
    if (!(whatsNew === null || whatsNew === void 0 ? void 0 : whatsNew.hasAnnouncements))
        return null;
    const { unreadCount, openDrawer, isDrawerOpen } = whatsNew;
    const label = intl.formatMessage(messages.whatsNew);
    return (React.createElement(SidebarPageItem, { label: label, icon: React.createElement(Sparkle, { width: SIDEBAR_ICON_SIZE, height: SIDEBAR_ICON_SIZE }), onClick: (event) => openDrawer(event.currentTarget), expanded: isDrawerOpen, ariaLabel: unreadCount > 0 ? intl.formatMessage(messages.whatsNewWithUnread, { count: unreadCount }) : label, badge: unreadCount > 0 && (React.createElement(PeekBox, { "data-testid": "whats-new-unread-count", "aria-hidden": true, sx: {
                minWidth: 20,
                height: 20,
                px: 0.75,
                borderRadius: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "teal.600",
            } },
            React.createElement(PeekTypography, { variant: "caption", sx: { color: "common.white", fontWeight: "fontWeightMedium" } }, unreadCount > MAX_SHOWN_COUNT ? `${MAX_SHOWN_COUNT}+` : unreadCount))) }));
};
export default WhatsNewSidebarItem;
